import React from 'react';
import { Info, Zap } from 'lucide-react';

/**
 * SharedSessionBanner — fixed at the top of the editor whenever
 * sessionType === 'shared_session'. Visually obvious; persistent.
 *
 * Props:
 *   onUpgrade   — opens UpgradeModal (required)
 *   onLearnMore — opens informational page or modal (required)
 */
export default function SharedSessionBanner({ onUpgrade, onLearnMore }) {
  return (
    <div
      data-testid="shared-session-banner"
      className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2.5 flex items-center justify-between text-sm shadow-md"
      role="alert"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Info className="w-4 h-4 flex-shrink-0" />
        <span className="font-medium truncate">
          Shared Template Session — Changes will not be saved.
        </span>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          type="button"
          onClick={onLearnMore}
          className="text-xs font-medium px-3 py-1 rounded-md border border-white/40 hover:bg-white/10 transition-colors"
        >
          Learn More
        </button>
        <button
          type="button"
          onClick={onUpgrade}
          className="text-xs font-bold px-3 py-1 rounded-md bg-white text-orange-700 hover:bg-orange-50 transition-colors flex items-center gap-1"
        >
          <Zap className="w-3 h-3" />
          Upgrade to Pro
        </button>
      </div>
    </div>
  );
}
